import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOnlineQuoteForm } from 'routes/online_quotes/content/onlineQuoteFormSlice';

import validateEmail from 'utils/validateEmail';

const Primary = ({ reset, showErrors = false }) => {

  // REDUX HANDLING
  const dispatch = useDispatch()
  const onlineQuoteForm = useSelector((state) => state.onlineQuoteForm.value)


  // DATA HANDLING
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  useEffect(() => {
    if (reset) {

      setFormData({
        firstName: '',
        lastName: '',
        email: '',
      })

      // Reset Form
      dispatch(setOnlineQuoteForm({
        package: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        age: '',
        gender: '',
        state: '',
        zipCode: '',
        tobaccoUser: '',
        medications: '',
        spouseAge: '',
        numberOfDependents: '',
        dependent1Age: '',
        dependent2Age: '',
        dependent3Age: '',
        dependent4Age: '',
        dependent5Age: '',
        dependent6Age: '',
        dependent7Age: '',
    }));
    }
  }, [reset, dispatch]);

  useEffect(() => {
    setFormData({
      firstName: onlineQuoteForm.firstName,
      lastName: onlineQuoteForm.lastName,
      email: onlineQuoteForm.email,
    })
  }, []);
  


  useEffect(() => {
      dispatch(setOnlineQuoteForm(formData))
  }, [formData, dispatch]);

  const firstNameInvalid = showErrors && !formData.firstName?.trim();
  const lastNameInvalid = showErrors && !formData.lastName?.trim();
  const emailEmpty = showErrors && !formData.email?.trim();
  const emailFormatInvalid = showErrors && Boolean(formData.email?.trim()) && !validateEmail(formData.email);
  const emailInvalid = emailEmpty || emailFormatInvalid;

  return (
    <>
      <label className="form-control w-full px-2 py-1" data-invalid={firstNameInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">First Name <span className="text-error">*</span></span>
          {firstNameInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
        </div>
        <input
          autoComplete='off'
          type="text"
          placeholder="Your answer"
          className={`input input-sm input-bordered w-full ${firstNameInvalid ? 'input-error border-2 border-red-600 bg-red-50' : ''}`}
          name="firstName"
          value={formData.firstName}
          onChange={handleInputChange}
        />
      </label>


      <label className="form-control w-full px-2 py-1" data-invalid={lastNameInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">Last Name <span className="text-error">*</span></span>
          {lastNameInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
        </div>
        <input
          autoComplete='off'
          type="text"
          placeholder="Your answer"
          className={`input input-sm input-bordered w-full ${lastNameInvalid ? 'input-error border-2 border-red-600 bg-red-50' : ''}`}
          name="lastName"
          value={formData.lastName}
          onChange={handleInputChange}
        />
      </label>


      <label className="form-control w-full px-2 py-1" data-invalid={emailInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">Email <span className="text-error">*</span></span>
          {emailEmpty && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
          {emailFormatInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Invalid Email</span>}
        </div>
        <input
          autoComplete='off'
          type="email"
          placeholder="Your answer"
          className={`input input-sm input-bordered w-full ${emailInvalid ? 'input-error border-2 border-red-600 bg-red-50' : ''}`}
          name="email"
          value={formData.email}
          onChange={handleInputChange}
        />
      </label>

    </>
  );
}

export default Primary;
